export enum CurrencySymbolEnum {
  Dolar = '$ Dolar',
  Euro = '€ Euro',
}